export const ignoredErrors = [
  'Failed to fetch', // Chrome
  'NetworkError when attempting to fetch resource.', // Firefox
  'cancelled', // Safari / iOS
  'Cancelled', // Safari / iOS
]
